import { render } from "./BeneficiaryRowMitchell.vue?vue&type=template&id=a1b50200&scoped=true"
import script from "./BeneficiaryRowMitchell.vue?vue&type=script&lang=js"
export * from "./BeneficiaryRowMitchell.vue?vue&type=script&lang=js"

import "./BeneficiaryRowMitchell.vue?vue&type=style&index=0&id=a1b50200&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b50200"]])

export default __exports__